import Trains from './Trains';

export default Trains;